// extracted by mini-css-extract-plugin
export default {"wrapper":"description_wrapper__KvUSD","title":"description_title__z6F1o","webLinksContainer":"description_webLinksContainer__9WN09"};